export function rmsToDb(samples: Float32Array): number {
  if (samples.length === 0) return -100;
  let sumSquares = 0;
  for (const sample of samples) sumSquares += sample * sample;
  const rms = Math.sqrt(sumSquares / samples.length);
  if (rms <= 0.00001) return -100;
  return Math.max(-100, Math.min(0, 20 * Math.log10(rms)));
}

export class NoiseAlert {
  private aboveSince: number | null = null;
  private alertUntil = 0;

  constructor(
    public thresholdDb: number,
    private readonly triggerAfterMs = 500,
    private readonly holdForMs = 1_500,
  ) {}

  observe(levelDb: number, now = Date.now()): boolean {
    if (levelDb >= this.thresholdDb) {
      this.aboveSince ??= now;
      if (now - this.aboveSince >= this.triggerAfterMs) {
        this.alertUntil = now + this.holdForMs;
      }
    } else {
      this.aboveSince = null;
    }
    return now < this.alertUntil;
  }

  reset(): void {
    this.aboveSince = null;
    this.alertUntil = 0;
  }
}

export function meterPercent(db: number): number {
  return Math.max(0, Math.min(100, ((db + 80) / 80) * 100));
}
